import { useEffect, useState } from 'react';
import { TableColumn } from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useGetAdmins, useUpdateSystemUserRole } from "../../api/UserApi";
import ContentContainer from "../../components/ContainerComponents/ContentContainer";
import PaginatedDataTableClientSide from "../../components/DataTableComponents/PaginatedDataTable";
import { Role } from "../../core/enums/enums";
import { IUserResponse } from "../../core/interfaces/user";
import { useGetUser } from "../../hooks/useAuth";

const AdminTable = () => {
    const user = useGetUser();
    const {t} = useTranslation();
    const [data, loading] = useGetAdmins();
    const [copyEmailAddressesStatus, SetCopyEmailAddressesStatus] = useState<string>();
    const [copyEmailAddressesStatusColor, SetCopyEmailAddressesStatusColor] = useState<string>("green");

    const IsSuperAdmin = (): boolean => {
        return user.role === Role.SUPERADMIN;
    };

    const copyEmailAddressesAsStringToMemory = async () => {
        if (!data) return;
        if (loading) return;

        const emails = data
            .filter(user => user.isActiveInAnyCompany)
            .map(user => user.email);

        var emailString = emails.join(';');

        navigator.clipboard.writeText(emailString)
            .then(() => { 
                console.log(t('SuperadminTable.COPY_DATA_SUCCESS_MESSAGE'), emailString);
                SetCopyEmailAddressesStatus(emails.length + ' ' + t('SuperadminTable.COPY_DATA_SUCCESS_MESSAGE'));
                SetCopyEmailAddressesStatusColor("green");
            })
            .catch(err => {
                console.log("Administrator Emails: ", emailString);
                SetCopyEmailAddressesStatus(t('SuperadminTable.COPY_DATA_ERROR_MESSAGE'));
                SetCopyEmailAddressesStatusColor("red");
            });
    }

    const columns: TableColumn<IUserResponse>[] = [
        {
            name: t('AdminTable.COMPANY'),
            selector: row => `${row.companies?.[0].name}`,
            sortable: true,
        },
        {
            name: t('AdminTable.NAME'),
            selector: row => `${row.person.firstName} ${row.person.lastName}`,
            sortable: true,
        },
        {
            name: t('AdminTable.EMAIL'),
            selector: row => row.email,
            sortable: true,
        },
        {
            name: t("AdminTable.IN_ACTIVE_COMPANY"),
            selector: row => row.isActiveInAnyCompany ? t("AdminTable.YES") : t("AdminTable.NO"),
        },
    ];

    return (
        <ContentContainer>

            {IsSuperAdmin() && data && !loading && (
                <>
                    <div className="flex justify-center">
                        <button className="block mx-auto border p-2 rounded" onClick={() => copyEmailAddressesAsStringToMemory()}>
                            {t("AdminTable.COPY_EMAILS") + " ( " + data?.length + " )"}
                        </button>
                    </div>
                    <div className='text-center col' style={{ color: copyEmailAddressesStatusColor }}>{copyEmailAddressesStatus}</div>

                    <PaginatedDataTableClientSide
                        data={data ?? []}
                        progressPending={false}
                        columns={columns}
                        usePagination={false}
                    />
                </>
            )}

        </ContentContainer>
    );
};

export default AdminTable;
